import useSWR, { type SWRConfiguration } from 'swr';
import fetcherWithDataKey from '@/lib/swr/fetcherWithDataKey';
import type Opportunity from '@/types/api/Opportunity';

export default function useOpportunity(
  opportunityId: null | string,
  swrOptions?: SWRConfiguration,
) {
  return useSWR(
    opportunityId ? `opportunities/${opportunityId}` : null,
    fetcherWithDataKey<Opportunity>('opportunity'),
    swrOptions,
  );
}
